import React from 'react';
import { Headings } from '@arctheme-components/elements/Headings/Headings';
import { Paragraph } from '@arctheme-components/elements/Paragraph/Paragraph';
import { ProductTile } from '../../../ecommerce/Product/ProductTile';
import ListProductsCTA from '../ListProductsCTA/ListProductsCTA';
import useMobileBreakpoint from '@arctheme-hooks/useMobileBreakpoint';

export default function ListProductsScrollable({ products, settings }) {
  const {
    section,
    mobile_breakpoint,
    globals: { enable_wishlist }
  } = settings;
  const isMobile = useMobileBreakpoint(mobile_breakpoint);
  let ctaPosition = 'top';

  settings.show_price = section.product_tile_price_show;
  settings.show_quickadd = section.product_tile_quickadd_show;
  settings.show_tags = section.product_tile_tag_show;

  if (isMobile) {
    ctaPosition = 'bottom';
  }

  return (
    <div className='product-list scrollable-list'>
      <div className={'section-top'}>
        <div className={'section-bar w-full flex flex-row justify-between'}>
          <div className={'section-info'}>
            <Headings
              text={section?.title}
              type={'h5'}
              classes={`${isMobile ? section.header_style_mobile : section.header_style}`}
            />
            <Paragraph
              text={section?.subtext}
              type={section?.subtext_style}
            />
          </div>
          {ctaPosition === 'top' && (
            <ListProductsCTA
              section={section}
              isMobile={isMobile}
            />
          )}
        </div>
      </div>
      <div
        className={'w-full'}
        x-data='carouselFilter()'
      >
        <div className='row-start-1 col-start-1'>
          <div className='carousel-item-container w-full'>
            <div
              x-data='scrollable'
              className='product-list__scrollable w-full flex overflow-x-auto'
            >
              {products.map((product, id) => (
                <div
                  key={id}
                  className='carousel-item'
                  x-init='$nextTick(() => { initialise(false, true, false, false) })'
                >
                  <ProductTile
                    product={product}
                    swatches={product?.swatches}
                    siblings={undefined}
                    settings={settings}
                    enableWishlist={enable_wishlist}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={'section-bottom flex justify-center mt-4'}>
        {ctaPosition === 'bottom' && (
          <ListProductsCTA
            section={section}
            isMobile={isMobile}
          />
        )}
      </div>
    </div>
  );
}
